<pagination></pagination>
<div class="items">
  <applications-list-item *ngFor="let application of items" [application]="application"></applications-list-item>
</div>
<pagination></pagination>
